import { API } from 'utils/API';

const fetchRecommendedRestaurants = async () => {
  const { data } = await API.post(`restaurants/recommended`);
  return data;
};

export { fetchRecommendedRestaurants };
